export function deriveSchemaNameFromLabel(label: string): string {
  const base = label
    .trim()
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/['"]/g, '')
    .replace(/[^A-Za-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-+/g, '-')
    .toLowerCase()

  return /^[a-z]/.test(base) ? base : base ? `schema-${base}` : 'schema'
}
